import { Component, Input, TemplateRef } from '@angular/core';
import { ICautionContext } from '../adMessageConfig';

@Component({
  selector: 'ad-caution',
  templateUrl: './ad-caution.component.html',
  styleUrls: ['./ad-caution.component.scss'],
})
export class AdCautionComponent {
  @Input() title: string = 'Caution';
  @Input() titleIcon: string = 'fa fa-exclamation-triangle';
  @Input() message: string;
  @Input() addtionalBodyTemplate: TemplateRef<any>;
  @Input() footerTemplate: TemplateRef<any>;
  @Input() confirmText: string = 'Confirm';
  @Input() confirmIcon: string = 'fa fa-thumbs-o-up';
  @Input() cancelText: string = 'Go Back';
  @Input() cancelIcon: string = '';
  @Input() isCancelHidden: boolean = false;
  @Input() cautionContext: ICautionContext = {};
  @Input() confirmCallback: () => void;
  @Input() cancelCallback: () => void;
  @Input() includeDefaultComment: boolean = false;
  @Input() confirmBtnClass: string = 'ui-button-positive';
  @Input() cancelBtnClass: string = 'a-btn-link';
  @Input() style: any = { width: '30vw' };
  @Input() footerClass: string = '';

  constructor() { }

  onConfirm() {
    this.confirmCallback?.();
  }

  onCancel() {
    this.cancelCallback?.();
  }

  onCommentChange(param: any, context: ICautionContext) {
    if (context != null) {
      context.result = param.target.value;
    }
    context.confirmButtonDisable = !context?.result || !context.result.length;
  }
}
